var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.856,
    height: 13.429,
    viewBox: "0 0 14.856 13.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    width: 14.856,
    height: 13.429,
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#16161a",
    strokeWidth: 1.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3138",
    "data-name": "Group 3138",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3137",
    "data-name": "Group 3137",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8485",
    "data-name": "Path 8485",
    d: "M4.6.2H8.83a2.335,2.335,0,0,1,2,1.134L12.9,4.81a2.319,2.319,0,0,1,0,2.381l-2.073,3.475a2.335,2.335,0,0,1-2,1.134H4.6a2.335,2.335,0,0,1-2-1.134L.528,7.19a2.323,2.323,0,0,1,0-2.381L2.6,1.334A2.335,2.335,0,0,1,4.6.2Zm4.233,10a.727.727,0,0,0,.622-.353l2.073-3.476a.722.722,0,0,0,0-.741L9.452,2.153A.727.727,0,0,0,8.83,1.8H4.6a.727.727,0,0,0-.622.353L1.9,5.629a.724.724,0,0,0,0,.742L3.975,9.847A.727.727,0,0,0,4.6,10.2Z",
    transform: "translate(-0.286 -0.286)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8486",
    "data-name": "Path 8486",
    d: "M8.112,4.4a2.837,2.837,0,0,1,2.866,2.8,2.867,2.867,0,0,1-5.732,0A2.837,2.837,0,0,1,8.112,4.4Zm0,4A1.2,1.2,0,1,0,6.846,7.2,1.236,1.236,0,0,0,8.112,8.4Z",
    transform: "translate(-1.727 -1.486)",
    fill: "#16161a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2783c78b920d853794891176a5892790.svg";
export { ForwardRef as ReactComponent };